import { FC } from 'react';
import { Empty } from 'antd';
import dayjs from 'dayjs';
import { APPOINTMENT_CREATOR } from 'constants/appointments';
import { FULL_DATE_FORMAT } from 'constants/dates';

import { useAppointmentDetail } from 'pages/AppointmentsDetails/AppointmentDetailContext';
import { CardNote } from 'components/ui';

const Notes: FC = () => {
  const { appointment } = useAppointmentDetail();

  return (
    <>
      {appointment?.notes?.length ? (
        appointment?.notes.map(item => (
          <CardNote
            key={`card-item-${item.id}`}
            title={
              item.sender === APPOINTMENT_CREATOR.doctor
                ? `${appointment?.doctor?.first_name ?? ''} ${
                    appointment?.doctor?.last_name ?? ''
                  }`
                : `${appointment?.patient?.first_name ?? ''} ${
                    appointment?.patient?.last_name ?? ''
                  }`
            }
            content={item?.note || ''}
            date={dayjs(item?.created_at).format(FULL_DATE_FORMAT)}
          />
        ))
      ) : (
        <Empty />
      )}
    </>
  );
};

export default Notes;
